// extracted by mini-css-extract-plugin
module.exports = {"greeting":"main_greeting__3Eblh","viz-wrapper":"main_viz-wrapper__1iEq9"};